var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { updateLongReadPost } from '../../../../actions/updateLongReadPost';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import urlApi from '../../../../actions/urlApi';
import { Endpoints } from '@brg/api';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import FileInput from '@uppy/file-input';
import { MEDIA_QUERY, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import { useResizedImage } from '@brg/ui';
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import useCommonProps from "../../../../hooks/useCommonProps";
import { MobileEditorActions } from '../../../../constants/mobileEditorActions';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: #ffffff;\n  display: none;\n  z-index: 343422;\n  @media (max-width: ", "px) {\n    display: block;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: #ffffff;\n  display: none;\n  z-index: 343422;\n  @media (max-width: ", "px) {\n    display: block;\n  }\n"])), MEDIA_QUERY_MOBILE);
var Header = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(21, 21, 20, 0.31);\n  padding-left: 12px;\n  padding-right: 12px;\n"], ["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(21, 21, 20, 0.31);\n  padding-left: 12px;\n  padding-right: 12px;\n"])));
var HeaderItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var AreaWrap = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 48px;\n  padding-left: 12px;\n  padding-right: 12px;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  img {\n    opacity: ", ";\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n\n  input[type='file'] {\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  margin-top: 48px;\n  padding-left: 12px;\n  padding-right: 12px;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  img {\n    opacity: ", ";\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n\n  input[type='file'] {\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) { return (props.isLoading ? 0.5 : 1); });
var Footer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: fixed;\n  right: 0;\n  left: 0;\n  bottom: ", ";\n  background: #ffffff;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n"], ["\n  position: fixed;\n  right: 0;\n  left: 0;\n  bottom: ", ";\n  background: #ffffff;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n"])), function (props) { return (props.isUpdate ? '48px' : 0); });
var FooterItem = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  opacity: ", ";\n"], ["\n  width: 32px;\n  height: 32px;\n  opacity: ", ";\n"])), function (props) { return (props.isLoading ? 0.5 : 1); });
function BottomImageEditor(props) {
    var _a, _b, _c;
    var toggleSubmenu = props.toggleSubmenu, submenu = props.submenu, lgid = props.lgid, isUpdate = props.isUpdate, post = props.post, getLongReadPosts = props.getLongReadPosts;
    var _d = useState(false), toggle = _d[0], setToggle = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(isUpdate ? post : {}), updatedPost = _f[0], setUpdatedPost = _f[1];
    var _g = useState(''), imageId = _g[0], setImageId = _g[1];
    var _h = useState(''), bigImageSrc = _h[0], setBigImageSrc = _h[1];
    var dispatch = useDispatch();
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, lgid); });
    var blocks = currentStore.blocks;
    var userid = localStorage.getItem('userId');
    var bigimageRef = useRef(null);
    var _j = useCommonProps(), sign = _j.sign, mobileEditorAction = _j.mobileEditorAction, toggleMobileEditor = _j.toggleMobileEditor, onLongreadIsReady = _j.coverContent.onLongreadIsReady;
    var uppy = new Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        allowMultipleUploads: true,
        meta: { type: 'image/jpeg' },
        autoProceed: true,
        onBeforeUpload: function (files) {
            setIsLoading(true);
        }
    })
        .use(Tus, {
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304
    })
        .use(FileInput, {
        target: bigimageRef.current,
        id: 'bigimage',
        pretty: true,
        inputName: 'files[]',
        locale: {}
    });
    uppy.on('complete', function (result) {
        try {
            var fileData 
            // в данном случае 2 кейса: первый если пост пришел. то редактируем его
            = void 0;
            // в данном случае 2 кейса: первый если пост пришел. то редактируем его
            if (post) {
                // редактирование для случаев если уже есть прикрепленные картинки или нет
                if (post.attachments.length === 0) {
                    fileData = {
                        fileId: '',
                        containerId: 'string',
                        isNew: true,
                        type: 'string',
                        url: 'string',
                        size: 'string',
                        localization: 'string'
                    };
                }
                else {
                    fileData = post.attachments[0] && post.attachments[0].file;
                }
                var url = result.successful[0].uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                var newAttach = __assign(__assign({}, post.attachments[0]), { file: { fileData: fileData, fileId: id, isNew: true } });
                var newAttachments = __spreadArray([newAttach], post.attachments, true);
                setUpdatedPost(__assign(__assign({}, post), { attachments: newAttachments }));
                setImageId(id);
                setIsLoading(false);
            }
            else {
                // второй кейс если поста нет, то создать новый
                var url = result.successful[0].uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                setImageId(id);
                setIsLoading(false);
            }
        }
        catch (e) {
            console.error(e);
        }
    });
    var savePost = function () {
        if (!isLoading) {
            if (isUpdate) {
                var newPost = __assign({}, post);
                var newAttach = __spreadArray([], post.attachments, true);
                //newPost.text = textvalue;
                dispatch(updateLongReadPost(imageId, updatedPost));
                dispatch(toggleLongReadPostUpdate(0, false, lgid));
                setTimeout(function () { return props.getLongReadPosts(userid, lgid, sign); }, 1000);
                //  в целом не зависит от запроса, можно не дожидаться
                toggleMobileEditor && toggleMobileEditor(false);
                //toggleSubmenu("");
            }
            else {
                dispatch(addLongReadPost({
                    id: userid,
                    title: '',
                    text: '',
                    color: 'white',
                    imageid: imageId,
                    lgid: lgid,
                    isFL: false,
                    imgCaption: '',
                    style: 'image',
                    num: blocks.length,
                    imageData: '',
                    sign: sign
                }));
                setTimeout(function () { return props.getLongReadPosts(userid, lgid, sign); }, 1000);
                //  в целом не зависит от запроса, можно не дожидаться
                toggleSubmenu('');
            }
        }
    };
    var addFile = function (event, style, droppedFiles) {
        // добавление и отображение добавленной картинки
        var files;
        //console.log(Array.from(event.target.files))
        if (event === null) {
            files = droppedFiles;
        }
        else {
            files = Array.from(event.target.files);
        }
        // случай для одного загруженного файла, все как обычно
        if (files.length === 1) {
            var fr_1 = new FileReader();
            uppy.reset();
            files.forEach(function (file) {
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    });
                }
                catch (err) {
                    if (err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err);
                    }
                    else {
                        // handle other errors
                        console.error(err);
                    }
                }
                fr_1.onload = function () {
                    if (style === 'big' || style === 'image') {
                        // console.log(fr.result);
                        setBigImageSrc(fr_1.result);
                    }
                };
                fr_1.readAsDataURL(files[0]);
            });
        }
    };
    var closeEditor = function () {
        uppy.close();
        if (!isUpdate) {
            toggleSubmenu('');
        }
        if (isUpdate) {
            dispatch(toggleLongReadPostUpdate(0, false, lgid));
        }
    };
    useEffect(function () {
        if (!isUpdate) {
            bigimageRef.current.click();
        }
    }, []);
    // Обновляет портал с редактором
    useEffect(function () { return onLongreadIsReady && onLongreadIsReady(Date.now()); }, []);
    useEffect(function () {
        if (mobileEditorAction === MobileEditorActions.add) {
            savePost();
        }
        if (mobileEditorAction === MobileEditorActions.close) {
            closeEditor();
        }
    }, [mobileEditorAction]);
    var _k = useResizedImage((_c = (_b = (_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.files) !== null && _c !== void 0 ? _c : []), image = _k[0], imgContainer = _k[1];
    return (React.createElement(Wrap, { className: 'js-mobile-image-editor' },
        React.createElement(AreaWrap, { isLoading: isLoading, ref: imgContainer },
            React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: bigimageRef, onChange: function (e) { return addFile(e, 'image'); } }),
            React.createElement("img", { src: isUpdate && !bigImageSrc
                    ? "".concat(urlApi().getImageQueryLink()).concat(image === null || image === void 0 ? void 0 : image.url)
                    : bigImageSrc, alt: 'big' }))));
}
var mapStateToProps = function (store) {
    return {};
};
var mapDispatchToProps = function (dispatch) {
    return {
        getLongReadPosts: function (idUser, idLongRead, sign) {
            return dispatch(getLongReadPosts(idUser, idLongRead, sign));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BottomImageEditor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=imageeditormobile.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { updateLongReadPost } from '../../../../actions/updateLongReadPost';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import urlApi from '../../../../actions/urlApi';
import { Endpoints } from '@brg/api';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import FileInput from '@uppy/file-input';
import { MEDIA_QUERY, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import { useResizedImage } from '@brg/ui';
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import useCommonProps from "../../../../hooks/useCommonProps";
import { MobileEditorActions } from '../../../../constants/mobileEditorActions';
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: #ffffff;\n  display: none;\n  z-index: 343422;\n  @media (max-width: ", "px) {\n    display: block;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: #ffffff;\n  display: none;\n  z-index: 343422;\n  @media (max-width: ", "px) {\n    display: block;\n  }\n"])), MEDIA_QUERY_MOBILE);
var Header = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(21, 21, 20, 0.31);\n  padding-left: 12px;\n  padding-right: 12px;\n"], ["\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: rgba(21, 21, 20, 0.31);\n  padding-left: 12px;\n  padding-right: 12px;\n"])));
var HeaderItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var AreaWrap = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 48px;\n  padding-left: 12px;\n  padding-right: 12px;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  img {\n    opacity: ", ";\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n\n  input[type='file'] {\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  margin-top: 48px;\n  padding-left: 12px;\n  padding-right: 12px;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  img {\n    opacity: ", ";\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n\n  input[type='file'] {\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n  }\n"])), function (props) { return (props.isLoading ? 0.5 : 1); });
var Footer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: fixed;\n  right: 0;\n  left: 0;\n  bottom: ", ";\n  background: #ffffff;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n"], ["\n  position: fixed;\n  right: 0;\n  left: 0;\n  bottom: ", ";\n  background: #ffffff;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 12px;\n  padding-right: 12px;\n  width: 100%;\n"])), function (props) { return (props.isUpdate ? '48px' : 0); });
var FooterItem = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  opacity: ", ";\n"], ["\n  width: 32px;\n  height: 32px;\n  opacity: ", ";\n"])), function (props) { return (props.isLoading ? 0.5 : 1); });
function BottomImageEditor(props) {
    var _a, _b, _c;
    var toggleSubmenu = props.toggleSubmenu, submenu = props.submenu, lgid = props.lgid, isUpdate = props.isUpdate, post = props.post, getLongReadPosts = props.getLongReadPosts;
    var _d = useState(false), toggle = _d[0], setToggle = _d[1];
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(isUpdate ? post : {}), updatedPost = _f[0], setUpdatedPost = _f[1];
    var _g = useState(''), imageId = _g[0], setImageId = _g[1];
    var _h = useState(''), bigImageSrc = _h[0], setBigImageSrc = _h[1];
    var dispatch = useDispatch();
    var currentStore = useSelector(function (store) { return getCurrentLongread(store, lgid); });
    var blocks = currentStore.blocks;
    var userid = localStorage.getItem('userId');
    var bigimageRef = useRef(null);
    var _j = useCommonProps(), sign = _j.sign, mobileEditorAction = _j.mobileEditorAction, toggleMobileEditor = _j.toggleMobileEditor, onLongreadIsReady = _j.coverContent.onLongreadIsReady;
    var uppy = new Uppy({
        restrictions: { maxNumberOfFiles: 1 },
        allowMultipleUploads: true,
        meta: { type: 'image/jpeg' },
        autoProceed: true,
        onBeforeUpload: function (files) {
            setIsLoading(true);
        }
    })
        .use(Tus, {
        endpoint: "".concat(Endpoints.uploader, "/upload/"),
        chunkSize: 4194304
    })
        .use(FileInput, {
        target: bigimageRef.current,
        id: 'bigimage',
        pretty: true,
        inputName: 'files[]',
        locale: {}
    });
    uppy.on('complete', function (result) {
        try {
            var fileData 
            // в данном случае 2 кейса: первый если пост пришел. то редактируем его
            = void 0;
            // в данном случае 2 кейса: первый если пост пришел. то редактируем его
            if (post) {
                // редактирование для случаев если уже есть прикрепленные картинки или нет
                if (post.attachments.length === 0) {
                    fileData = {
                        fileId: '',
                        containerId: 'string',
                        isNew: true,
                        type: 'string',
                        url: 'string',
                        size: 'string',
                        localization: 'string'
                    };
                }
                else {
                    fileData = post.attachments[0] && post.attachments[0].file;
                }
                var url = result.successful[0].uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                var newAttach = __assign(__assign({}, post.attachments[0]), { file: { fileData: fileData, fileId: id, isNew: true } });
                var newAttachments = __spreadArray([newAttach], post.attachments, true);
                setUpdatedPost(__assign(__assign({}, post), { attachments: newAttachments }));
                setImageId(id);
                setIsLoading(false);
            }
            else {
                // второй кейс если поста нет, то создать новый
                var url = result.successful[0].uploadURL;
                var linkT = url.split('/');
                var lngh = linkT.length - 1;
                var id = linkT[lngh];
                setImageId(id);
                setIsLoading(false);
            }
        }
        catch (e) {
            console.error(e);
        }
    });
    var savePost = function () {
        if (!isLoading) {
            if (isUpdate) {
                var newPost = __assign({}, post);
                var newAttach = __spreadArray([], post.attachments, true);
                //newPost.text = textvalue;
                dispatch(updateLongReadPost(imageId, updatedPost));
                dispatch(toggleLongReadPostUpdate(0, false, lgid));
                setTimeout(function () { return props.getLongReadPosts(userid, lgid, sign); }, 1000);
                //  в целом не зависит от запроса, можно не дожидаться
                toggleMobileEditor && toggleMobileEditor(false);
                //toggleSubmenu("");
            }
            else {
                dispatch(addLongReadPost({
                    id: userid,
                    title: '',
                    text: '',
                    color: 'white',
                    imageid: imageId,
                    lgid: lgid,
                    isFL: false,
                    imgCaption: '',
                    style: 'image',
                    num: blocks.length,
                    imageData: '',
                    sign: sign
                }));
                setTimeout(function () { return props.getLongReadPosts(userid, lgid, sign); }, 1000);
                //  в целом не зависит от запроса, можно не дожидаться
                toggleSubmenu('');
            }
        }
    };
    var addFile = function (event, style, droppedFiles) {
        // добавление и отображение добавленной картинки
        var files;
        //console.log(Array.from(event.target.files))
        if (event === null) {
            files = droppedFiles;
        }
        else {
            files = Array.from(event.target.files);
        }
        // случай для одного загруженного файла, все как обычно
        if (files.length === 1) {
            var fr_1 = new FileReader();
            uppy.reset();
            files.forEach(function (file) {
                try {
                    uppy.addFile({
                        source: 'file input',
                        name: file.name,
                        type: file.type || 'application/octet-stream',
                        data: file,
                        meta: {
                            contentType: file.type || 'application/octet-stream'
                        }
                    });
                }
                catch (err) {
                    if (err.isRestriction) {
                        // handle restrictions
                        console.error('Restriction error:', err);
                    }
                    else {
                        // handle other errors
                        console.error(err);
                    }
                }
                fr_1.onload = function () {
                    if (style === 'big' || style === 'image') {
                        // console.log(fr.result);
                        setBigImageSrc(fr_1.result);
                    }
                };
                fr_1.readAsDataURL(files[0]);
            });
        }
    };
    var closeEditor = function () {
        uppy.close();
        if (!isUpdate) {
            toggleSubmenu('');
        }
        if (isUpdate) {
            dispatch(toggleLongReadPostUpdate(0, false, lgid));
        }
    };
    useEffect(function () {
        if (!isUpdate) {
            bigimageRef.current.click();
        }
    }, []);
    // Обновляет портал с редактором
    useEffect(function () { return onLongreadIsReady && onLongreadIsReady(Date.now()); }, []);
    useEffect(function () {
        if (mobileEditorAction === MobileEditorActions.add) {
            savePost();
        }
        if (mobileEditorAction === MobileEditorActions.close) {
            closeEditor();
        }
    }, [mobileEditorAction]);
    var _k = useResizedImage((_c = (_b = (_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.files) !== null && _c !== void 0 ? _c : []), image = _k[0], imgContainer = _k[1];
    return (React.createElement(Wrap, { className: 'js-mobile-image-editor' },
        React.createElement(AreaWrap, { isLoading: isLoading, ref: imgContainer },
            React.createElement("input", { type: 'file', accept: "image/jpeg, image/gif, image/png", ref: bigimageRef, onChange: function (e) { return addFile(e, 'image'); } }),
            React.createElement("img", { src: isUpdate && !bigImageSrc
                    ? "".concat(urlApi().getImageQueryLink()).concat(image === null || image === void 0 ? void 0 : image.url)
                    : bigImageSrc, alt: 'big' }))));
}
var mapStateToProps = function (store) {
    return {};
};
var mapDispatchToProps = function (dispatch) {
    return {
        getLongReadPosts: function (idUser, idLongRead, sign) {
            return dispatch(getLongReadPosts(idUser, idLongRead, sign));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BottomImageEditor);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=imageeditormobile.js.map